// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"ce3777a29fbe2e53cd81","913":"edda6941d3a976d5ceb1"}[chunkId] + ".js";
};